
import { SaleConfig } from "@/models/dossier-configs/sale-config";
import { SaleConfigStock } from "@/models/dossier-configs/sale-config-stock";
import { StockLocationConfig } from "@/models/dossier-configs/stock-location";
import { DossierConfigService } from "@/services";
import Vue from "vue";
import AppEditPerDocumentStockSettingsModal from "./EditPerDocumentStockSettingsModal.vue";

export default Vue.extend({
	data(){
		return {
			toEditConfIndex: -1,
		};
	},
	props: {
		config: {
			type: Object as ()=>SaleConfig,
			required: true
		}
	},
	computed: {
		toEditConf():SaleConfigStock |undefined{
			if (this.toEditConfIndex == -1) {
				return undefined;
			}
			return this.config.Stocks[this.toEditConfIndex];
		},
		stockNameSettings():StockLocationConfig {
			return DossierConfigService.getStockLocationConfig();
		}
	},
	methods: {
		addStockComputeItem() {
			if (!this.config) return;
			if (this.config.Stocks.length >= 9) return;
			let item = new SaleConfigStock();
			item.StockLocation = 1;
			this.config.Stocks.push(item);
			this.toEditConfIndex = this.config.Stocks.length-1;
		},
		editStockConfig(index:number) {
			this.toEditConfIndex = index;
		},
		removeStockConfig(i: number) {
			if (!this.config) return;
			this.config.Stocks.splice(i, 1);
		},
		onEditConfInput(value:SaleConfigStock){
			this.config.Stocks[this.toEditConfIndex] = value;
		},
		getStockLocationName(value:SaleConfigStock):string {
			return this.stockNameSettings.getLocationName(value.StockLocation);
		}
	},
	components: {
		AppEditPerDocumentStockSettingsModal
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
